import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Journal } from './journal.interface';
import { Transaction } from '../../../app/transactionform/transaction.interface';
import {
  DataService,
  OperationsService,
  StorageService
} from '../../_services/index';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {Router} from '@angular/router';
@Component({
  selector: 'app-newjournal',
  templateUrl: './newjournal.component.html',
  styleUrls: ['./newjournal.component.css']
})
export class NewjournalComponent implements OnInit {
  @Input('com_accounts') com_accounts: any;
  @Input('people_customers') people_customers: any;
  @Input('currentUser') currentUser: any;
  @Input('edit') edit: any;
  @Input('journals') journals: any;
  @Input('new_journal_overlay') new_journal_overlay: boolean;
  @Output() doTheTransfer = new EventEmitter();
  // @Output() editRecord = new EventEmitter();
  journal: Journal;
  updateJournal = false;
  debits = [];
  credits = [];
  issearching = false;
  secOpen = 'total';
  has_error = false;
  isediting = false;
  transactions: any;
  @Input('loading') loading = false;
  @Output() saveTheJournal = new EventEmitter();
  @Output() approveTheJournal = new EventEmitter();
  @Output() rejectTheJournal = new EventEmitter();
  // errors = { DATE_ADDED: false, NARRATION: false };
  savedJournals: any[];
  addedJournals: any[];
  total_credits: any;
  total_debits: any;
  record: any;
  transaction: Transaction;
  credit_total: any;
  debit_total: any;
  arr_index: any;
  view = 'add_transaction';
  page_view = 'full_transactions';
  end: boolean;
  date_added: any;
  description: any;
  transaction_amount: any;
  credit_account: any;
  debit_account: any;
  accounts: any;
  journal_view: any = 'company';
  search_name: string;
  customers_with_booked_loans: any;
  customer_loans: any;
  customer_loan_id: any;
  account_name: any;
  account_id: any;
  GL_ACCOUNT_ID: any;
  legal_name: any;
  credit_list: any;
  debit_list: any;
  errors = {
    DATE_ADDED: false,
    IFN: false,
    ACCOUNT_ID: false,
    OTHER_FORM_TYPE: false,
    LOANS: false,
    INVESTMENTS: false,
    NARRATION: false,
    ISA: false,
    CREDIT: false,
    DEBIT: false
  };
  investments: any;
  loans: any;
  disable_debit_field: boolean;
  disable_credit_field: boolean;
  selectedCustomer: any;
  customerSelected = false;
  searchCustomers = false;
  constructor(
    private dataService: DataService,
    private http: HttpClient,
    private operationService: OperationsService,
    private storageService: StorageService,
    private toastr: ToastrService,
    private router: Router,
  ) {
    this.dataService.onEditCredit.subscribe(res => {
      this.transaction = res.credit;
    });
    this.dataService.onEditDebit.subscribe(res => {
      this.transaction = res.debit;
    });
    this.dataService.emitJournals.subscribe(res => {
      this.credits = res.credit;
      this.debits = res.debit;
      this.total_credits = this.credits.reduce(
        (a, b) => a + parseFloat(b.CREDIT),
        0
      );
      this.total_debits = this.debits.reduce(
        (a, b) => a + parseFloat(b.DEBIT),
        0
      );
      // this.addedJournals = res;

      // if (JSON.parse(localStorage.getItem('debit_transactions')) || JSON.parse(localStorage.getItem('credit_transactions')) != null) {
      //   // this.addedJournals = JSON.parse(localStorage.getItem('saved_journals'));
      //   this.credits = JSON.parse(localStorage.getItem('credit_transactions'));
      //   this.total_credits = this.credits.reduce(
      //     (a, b) => a + parseFloat(b.CREDIT),
      //     0
      //   );
      //   this.debits = JSON.parse(localStorage.getItem('debit_transactions'));
      //   this.total_debits = this.debits.reduce(
      //     (a, b) => a + parseFloat(b.DEBIT),
      //     0
      //   );
      //   // this.credits = this.addedJournals.filter(trans => {
      //   //   return trans.TTYPE == 2;
      //   // });
      //   // this.total_credits = this.credits.reduce(
      //   //   (a, b) => a + parseFloat(b.CREDIT),
      //   //   0
      //   // );
      //   // this.total_credits = this.credits.reduce((a, b) => {
      //   //   return a.AMOUNT_ + b.AMOUNT_;
      //   // }, 0);
      //   // this.debits = this.addedJournals.filter(trans => {
      //   //   return trans.TTYPE == 1;
      //   // });
      //   // this.total_debits = this.debits.reduce(
      //   //   (a, b) => a + parseFloat(b.DEBIT),
      //   //   0
      //   // );
      // }
    });
    this.dataService.changeJournalView.subscribe(() => {
      this.journal = {
        DATE_ADDED: '',
        NARRATION: '',
        USE_AS_SUB: false,
        USE_AS_DATE: false,
        JOURNAL_ENTRY_ID: '',
        TOTAL_CREDIT: '',
        TOTAL_DEBIT: '',
        NARRATIVE: '',
        IS_APPROVED: ''
      };
    });
    this.dataService.removeTransactions.subscribe((res) => {
      // this.credits = res.credit;
      // this.debits = res.debit;
      // this.addedJournals = res.addedJournals;
    });
  }

  ngOnInit() {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.debit_list = [];
    this.credit_list = [];
    this.transaction = {
      DATE_ADDED: '',
      IFN: '',
      ACCOUNT_ID: '',
      OTHER_FORM_TYPE: '0',
      LOANS: '',
      INVESTMENTS: '',
      NARRATION: '',
      ISA: '0',
      TTYPE: '',
      LOAN_ID: '',
      CREDIT: '',
      DEBIT: ''
    };
    this.displayAccounts();
    // if (JSON.parse(localStorage.getItem('debit_transactions')) && JSON.parse(localStorage.getItem('credit_transactions')) != null) {
    //   // this.addedJournals = JSON.parse(localStorage.getItem('saved_journals'));
    //   this.credits = JSON.parse(localStorage.getItem('credit_transactions'));
    //   this.total_credits = this.credits.reduce(
    //     (a, b) => a + parseFloat(b.CREDIT),
    //     0
    //   );
    //   this.debits = JSON.parse(localStorage.getItem('debit_transactions'));
    //   this.total_debits = this.debits.reduce(
    //     (a, b) => a + parseFloat(b.DEBIT),
    //     0
    //   );
    // }
    this.journal = {
      DATE_ADDED: '',
      NARRATION: '',
      USE_AS_SUB: false,
      USE_AS_DATE: false,
      JOURNAL_ENTRY_ID: '',
      TOTAL_DEBIT: 0,
      TOTAL_CREDIT: 0,
      IS_APPROVED: '',
      NARRATIVE: ''
    };
    if (this.edit) {
      this.journal = {
        DATE_ADDED: this.journals.JOURNAL_DATE,
        NARRATION: this.journals.NARRATIVE,
        USE_AS_SUB: this.journals.USE_AS_SUB,
        JOURNAL_ENTRY_ID: this.journals.JOURNAL_ENTRY_ID,
        TOTAL_DEBIT: parseFloat(this.journals.TOTAL_DEBIT),
        TOTAL_CREDIT: parseFloat(this.journals.TOTAL_CREDIT),
        IS_APPROVED: '',
        NARRATIVE: ''
      };
      this.debits = this.journals.debits;
      this.credits = this.journals.credits;
      // this.calculateJournal();
      this.issearching = true;
    }
    this.record = {
      ACCOUNT_ID: '',
      ACCOUNT_NAME: '',
      IFN: '',
      DEBIT: '',
      CREDIT: '',
      DATE_ADDED: '',
      NARRATION: '',
      TTYPE: ''
    };
    this.transaction = {
      DATE_ADDED: '',
      IFN: '',
      ACCOUNT_ID: '',
      OTHER_FORM_TYPE: '0',
      LOANS: '',
      INVESTMENTS: '',
      NARRATION: '',
      ISA: '0',
      TTYPE: '',
      LOAN_ID: '',
      CREDIT: '',
      DEBIT: ''
    };
    this.journal = {
      DATE_ADDED: '',
      JOURNAL_ENTRY_ID: '',
      NARRATION: '',
      TOTAL_CREDIT: 0,
      TOTAL_DEBIT: 0,
      USE_AS_DATE: false,
      USE_AS_SUB: false,
      IS_APPROVED: '',
      NARRATIVE: ''
    };
  }
  displayAccounts() {
    return this.operationService.displayAccounts(this.currentUser.token)
      .subscribe(res => {
        this.com_accounts = res.all_accounts;
      });
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  showSuccess(msg) {
    return this.toastr.success(msg, 'Success');
  }
  checkNarrationValue(e) {
    if (this.journal.USE_AS_SUB) {
      this.transaction.NARRATION = this.journal.NARRATION;
    }
  }
  checkDateValue(e) {
    if (this.journal.USE_AS_DATE) {
      this.transaction.DATE_ADDED = this.journal.DATE_ADDED;
    }
  }
  IFNVerification(debit_transaction, credit_transaction) {
    const IFN = debit_transaction.map((transaction) => {
      return transaction.IFN;
    });
    const IFN_ = credit_transaction.map((transaction) => {
      return transaction.IFN;
    });
    const IFNs = Array.from(new Set([...IFN, ...IFN_]));

    const IFN_Trans = [], IFN_Trans_Verification = {};

    IFNs.forEach((ifn) => {
      const ifn_obj = {
        id: '',
        credit: '',
        debit: '',
      };
      const credit_ifn = credit_transaction.filter((transaction) => {
        return transaction.IFN === ifn;
      }).map((trans) => trans.CREDIT);
      const debit_ifn = debit_transaction.filter((transaction) => {
        return transaction.IFN === ifn;
      }).map((trans) => trans.DEBIT);

      ifn_obj.id = ifn;
      ifn_obj.credit = credit_ifn;
      ifn_obj.debit = debit_ifn;

      IFN_Trans.push(ifn_obj);
    });

    IFN_Trans.forEach((IFN) => {
      const credit_sum = IFN.credit.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      const debit_sum = IFN.debit.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);

      IFN_Trans_Verification[IFN.id] = credit_sum === debit_sum;
    });

    return IFN_Trans_Verification;
  }
  saveJournal() {
    // do all validations
    this.errors.DATE_ADDED = false;
    this.has_error = false;
    let checkIFN = this.IFNVerification(this.debits, this.credits);
    if (Object.values(checkIFN).includes(false)) {
      return this.showError('The transactions IFN and amount is not balanced');
    }
    if (this.journal.DATE_ADDED == '') {
      this.errors.DATE_ADDED = true;
      this.updateJournal = true;
      return this.showError('Date cannot be empty');
    }
    if (this.journal.NARRATION == '') {
      this.errors.NARRATION = true;
      this.updateJournal = true;
      return this.showError('Narration cannot be empty');
    }
    if (this.total_debits === 0 && this.total_credits === 0) {
      this.has_error = true;
      return this.showError('Total credits and debits cannot be 0');
    }
    if (this.total_debits != this.total_credits) {
      this.has_error = true;
      return this.showError('Debit and credit must balance');
    }
    this.loading = true;
    this.transactions = this.credits.concat(this.debits);
    this.journal.TOTAL_CREDIT = this.total_debits;
    this.journal.TOTAL_DEBIT = this.total_credits;
    this.operationService
      .saveJournal(this.currentUser.token, this.transactions, this.journal)
      .subscribe(res => {
        this.loading = false;
        this.showSuccess('Journal added successfully');
        this.dataService.closeOverlayModal.emit(this.new_journal_overlay = false);
        this.journal = {
          DATE_ADDED: '',
          NARRATION: '',
          USE_AS_SUB: false,
          USE_AS_DATE: false,
          JOURNAL_ENTRY_ID: '',
          TOTAL_CREDIT: '',
          TOTAL_DEBIT: '',
          NARRATIVE: '',
          IS_APPROVED: ''
        };
        // localStorage.removeItem('debit_transactions');
        // localStorage.removeItem('credit_transactions');
        // if (JSON.parse(localStorage.getItem('saved_journals')) != null) {
        //   localStorage.removeItem('saved_journals');
        //   this.router.navigate(['operations/newjournal']);
        // }
      }, () => {
        this.loading = false;
        this.showError('An error occured, try again');
      });
    this.saveTheJournal.emit({
      journal: this.journal,
      debits: this.debits,
      credits: this.credits
    });
  }
  update() {
    this.transaction.ACCOUNT_NAME = this.account_name || this.record.ACCOUNT_NAME;
    this.transaction.ACCOUNT_ID = this.account_id || this.record.ACCOUNT_ID;
    this.transaction.DATE_ADDED = this.record.DATE_ADDED;
    this.transaction.DEBIT = this.record.DEBIT;
    this.transaction.CREDIT = this.record.CREDIT;
    this.transaction.NARRATION = this.record.NARRATION;
    this.transaction.IFN = this.record.IFN;
    this.transaction.TTYPE = this.record.TTYPE;
    if (this.transaction.CREDIT != 0) {
      this.transaction.TTYPE = 2;
      this.credits.splice(this.arr_index, 1, this.transaction);
      console.log(this.transaction);
      // localStorage.setItem('credit_transactions', JSON.stringify(this.credits));
      this.total_credits = this.credits.reduce(
        (a, b) => a + parseFloat(b.CREDIT),
        0
      );

    }
    if (this.transaction.DEBIT != 0) {
      this.transaction.TTYPE = 1;
      this.debits.splice(this.arr_index, 1, this.transaction);
      console.log(this.transaction);
      // localStorage.setItem('debit_transactions', JSON.stringify(this.debits));
      this.total_debits = this.debits.reduce(
        (a, b) => a + parseFloat(b.DEBIT),
        0
      );

    }

    // this.dataService.emitJournals.emit(savedtransactions);
    // this.doTheTransfer.emit(this.transaction);

    this.transaction = {
      DATE_ADDED: '',
      IFN: '',
      ACCOUNT_ID: '',
      OTHER_FORM_TYPE: '0',
      LOANS: '',
      INVESTMENTS: '',
      NARRATION: '',
      ISA: '0',
      TTYPE: '',
      LOAN_ID: '',
      ACCOUNT_NAME: '',
      CREDIT: '',
      DEBIT: ''
    };
    this.journal.USE_AS_DATE = false;
    this.journal.USE_AS_SUB = false;
    this.view = 'add_transaction';
  }
  approveJournal() {
    this.approveTheJournal.emit({
      journal: this.journal,
      debits: this.debits,
      credits: this.credits
    });
  }
  rejectJournal() {
    this.rejectTheJournal.emit({
      journal: this.journal,
      debits: this.debits,
      credits: this.credits
    });
  }
  doTransfer(event) {
    if (event.AMOUNT == '0') {
      this.credits.push(event);
    }
    if (event.AMOUNT_ == '0') {
      this.debits.push(event);
    }
    // this.calculateJournal();
  }
  deleteTransaction(type, i) {
    if (type == '1') {
      this.debits.splice(i, 1);
      this.total_debits = this.debits.reduce(
        (a, b) => a + parseFloat(b.DEBIT),
        0
      );
      // localStorage.setItem('debit_transactions', JSON.stringify(this.debits));
    }
    if (type == '2') {
      this.credits.splice(i, 1);
      this.total_credits = this.credits.reduce(
        (a, b) => a + parseFloat(b.CREDIT),
        0
      );
      // localStorage.setItem('credit_transactions', JSON.stringify(this.credits));

    }
    // this.calculateJournal();
  }
  editRecord(record, i) {
    this.view = 'edit_transaction';
    this.displayAccounts();
    this.arr_index = i;
    this.record.IFN = record.IFN;
    this.record.DEBIT = record.DEBIT;
    this.record.CREDIT = record.CREDIT;
    this.record.ACCOUNT_NAME = record.ACCOUNT_NAME;
    this.record.ACCOUNT_ID = record.ACCOUNT_ID;
    this.record.DATE_ADDED = record.DATE_ADDED;
    this.record.NARRATION = record.NARRATION;
  }
  // editRecord(record, i) {
  //   this.view = 'edit_transaction';
  //   this.arr_index = i;
  //   this.record.IFN = record.IFN;
  //   this.record.DEBIT = record.DEBIT;
  //   this.record.CREDIT = record.CREDIT;
  //   this.record.ACCOUNT_NAME = record.ACCOUNT_NAME;
  //   this.record.ACCOUNT_ID = record.ACCOUNT_ID;
  //   this.record.DATE_ADDED = record.DATE_ADDED;
  //   this.record.NARRATION = record.NARRATION;
  // }
  postTransaction() {
    if (!this.description) {
      return this.showError('Desciption cannot be empty');
    }
    if (!this.date_added) {
      return this.showError('Date cannot be empty');
    }
    if (!this.credit_account) {
      return this.showError('Credit account is required');
    }
    if (!this.debit_account) {
      return this.showError('Debit account is required');
    }
    if (!this.transaction_amount) {
      return this.showError('Transaction amount is required');
    }
    if (isNaN(this.transaction_amount) || this.transaction_amount <= 0) {
      return this.showError('Only numbers greater than 0 is required');
    }
    this.loading = true;
    const transaction_details = {
      token: this.currentUser.token,
      description: this.description,
      date: this.date_added,
      debit_account: this.debit_account,
      credit_account: this.credit_account,
      amount: this.transaction_amount
    };
    return this.operationService.postTransaction(transaction_details).subscribe(res => {
      if (res.status) {
        this.loading = false;
        this.showSuccess(res.reponse);
      } else {
        this.loading = false;
        this.showError(res.response);
      }
    }, () => {
      this.loading = false;
      this.showError('An error occurred, try again');
    });
  }
  save(formvalue, isvalid) {
    this.transaction.ACCOUNT_NAME = this.account_name || this.legal_name;
    this.transaction.ACCOUNT_ID = this.account_id || this.GL_ACCOUNT_ID;
    this.transaction.LOAN_ID = this.customer_loan_id;
    // this.transaction.ACCOUNT_ID = this.GL_ACCOUNT_ID;
    this.errors = {
      DATE_ADDED: false,
      IFN: false,
      ACCOUNT_ID: false,
      OTHER_FORM_TYPE: false,
      LOANS: false,
      INVESTMENTS: false,
      NARRATION: false,
      ISA: false,
      DEBIT: false,
      CREDIT: false
    };
    if (this.transaction.ACCOUNT_ID == '') {
      this.errors.ACCOUNT_ID = true;
      return this.showError('Select an account');
    }

    if (this.transaction.IFN == '') {
      this.errors.IFN = true;
      return this.showError('IFN is required');
    }

    if (this.transaction.ISA == '1') {
      if (this.transaction.OTHER_FORM_TYPE == '0') {
        this.errors.OTHER_FORM_TYPE = true;

        return;
      }
    }
    if (this.transaction.ISA == '1') {
      if (this.transaction.OTHER_FORM_TYPE == '1') {
        if (this.transaction.LOANS == '') {
          this.errors.LOANS = true;

          return;
        }
      }
      if (this.transaction.OTHER_FORM_TYPE == '2') {
        if (this.transaction.INVESTMENTS == '') {
          this.errors.INVESTMENTS = true;

          return;
        }
      }
    }
    if (this.transaction.DEBIT == '0' && this.transaction.CREDIT == '0') {
      this.errors.DEBIT = true;
      this.errors.CREDIT = true;
      return this.showError('Transaction amount cannot be 0');
    }
    if (this.transaction.CREDIT == '' && this.transaction.DEBIT == '') {
      this.errors.DEBIT = true;
      this.errors.CREDIT = true;
      return this.showError('Enter transaction amount');
    }
    if (this.transaction.DATE_ADDED == '') {
      this.errors.DATE_ADDED = true;

      return this.showError('Select date fo the transaction');
    }
    // let savedJournals;

    // if (localStorage.getItem('credit_transactions') || localStorage.getItem('debit_transactions') == null) {
    //   // savedJournals = [];
    //
    // } else {
    //   // savedJournals = JSON.parse(localStorage.getItem("saved_journals"));
    //   this.credits = JSON.parse(localStorage.getItem('credit_transactions'));
    //   this.debits = JSON.parse(localStorage.getItem('debit_transactions'));
    // }
    if (this.transaction.DEBIT != 0) {
      this.transaction.TTYPE = 1;
      this.debits.push(this.transaction);
    }
    if (this.transaction.CREDIT != 0) {
      this.transaction.TTYPE = 2;
      this.credits.push(this.transaction);
    }
    // localStorage.setItem('debit_transactions', JSON.stringify(this.debits));
    // localStorage.setItem('credit_transactions', JSON.stringify(this.credits));
    // savedJournals.push(this.transaction);
    // localStorage.setItem("saved_journals", JSON.stringify(savedJournals));
    this.dataService.emitJournals.emit({credit: this.credits, debit: this.debits});
    this.doTheTransfer.emit(this.transaction);
    if (this.journal.USE_AS_DATE) {
      this.transaction.DATE_ADDED = this.journal.DATE_ADDED;
    }
    if (this.journal.USE_AS_SUB) {
      this.transaction.NARRATION = this.journal.NARRATION;
    }
    this.transaction = {
      DATE_ADDED: '' || this.transaction.DATE_ADDED,
      IFN: '',
      ACCOUNT_ID: '',
      OTHER_FORM_TYPE: '0',
      LOANS: '',
      INVESTMENTS: '',
      NARRATION: '' || this.transaction.NARRATION,
      ISA: '0',
      TTYPE: '',
      LOAN_ID: '',
      ACCOUNT_NAME: '',
      DEBIT: '',
      CREDIT: ''
    };
    // this.journal.USE_AS_DATE = false;
    // this.journal.USE_AS_SUB = false;
  }

  changeOtherFormType(event) {
    this.operationService
      .getRecords(
        this.currentUser.token,
        this.transaction.ACCOUNT_ID.PEOPLE_CUSTOMERS_ID,
        event
      )
      .subscribe(options => {
        if (event == '1') {
          this.loans = options;
        }
        if (event == '2') {
          this.investments = options;
        }
      });
  }
  changeAccountType(event) {
    this.account_name = event.account_name;
    this.account_id = event.id;
    if (event.ACCOUNT_ID) {
      this.transaction.ISA = '2';
    }
    if (event.PEOPLE_CUSTOMERS_ID) {
      this.transaction.ISA = '1';
    }
  }
  changeView(e) {
    this.journal_view = e.target.value;
    this.dataService.changeJournalView.emit();
    this.transaction = {
      DATE_ADDED: '',
      IFN: '',
      ACCOUNT_ID: '',
      OTHER_FORM_TYPE: '0',
      LOANS: '',
      INVESTMENTS: '',
      NARRATION: '',
      ISA: '0',
      TTYPE: '',
      LOAN_ID: '',
      CREDIT: '',
      DEBIT: ''
    };
  }
  searchForCustomer() {
    this.customerSelected = false;
    return this.operationService
      .searchForCustomer(this.currentUser.token, this.search_name)
      .subscribe(res => {
        this.customers_with_booked_loans = res.people_with_booked_loans;
      });
  }
  selectCustomerWithLoan(customer) {
    this.selectedCustomer = customer;
    this.customerSelected = true;
    this.searchCustomers = false;
    this.selectCustomer(customer);
  }
  selectCustomer(params) {
    const customer_id = params.PEOPLE_ID;
    this.GL_ACCOUNT_ID = params.GL_ACCOUNT_ID;
    this.legal_name = params.LEGAL_NAME;
    return this.operationService
      .selectCustomer(this.currentUser.token, customer_id)
      .subscribe(res => {
        this.customer_loans = res.customer_loans;
      });
  }
  // calculateJournal() {
  //   this.journal.TOTAL_CREDIT = 0;
  //   this.journal.TOTAL_DEBIT = 0;
  //   let cr = 0;
  //   let dr = 0;
  //   this.credits.map(function(element) {
  //     cr = cr + parseFloat(element["AMOUNT_"]);
  //     //this.journal.TOTAL_DEBIT=this.journal.TOTAL_DEBIT+parseFloat(element["AMOUNT"]);
  //   });
  //   this.debits.map(function(element) {
  //     //this.journal.TOTAL_CREDIT=this.journal.TOTAL_CREDIT+parseFloat(element["AMOUNT_"]);
  //     dr = dr + parseFloat(element["AMOUNT"]);
  //   });
  //   this.journal.TOTAL_CREDIT = cr;
  //   this.journal.TOTAL_DEBIT = dr;
  // }
}
